export default __webpack_public_path__ + "static/media/image-18.3cab996d.png";